// Partial — admin/refunds routes (issue #189, WAVE D2).
// Covers: /admin/refunds (list), /admin/refunds/:id (detail).
// The /admin/refunds gate (admin OR support) lives in roleBoundary.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const RefundRequestsListPage = lazyWithRetry(
  () => import("./pages/RefundRequestsListPage"),
);
const RefundRequestDetailPage = lazyWithRetry(
  () => import("./pages/RefundRequestDetailPage"),
);

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/refunds", Component: RefundRequestsListPage },
      { path: "/admin/refunds/:id", Component: RefundRequestDetailPage },
    ],
  },
];

export default routes;
